import { TRUSTPILOT_REVIEW } from "constants/configConstants";

const formatTrustpilotCount = (count: any, kSuffix = "K", mSuffix = "M") => {
  try {
    if (!__CLIENT__) return TRUSTPILOT_REVIEW;

    if (count === undefined || count === null) {
      return TRUSTPILOT_REVIEW;
    }
    if (Number.isNaN(count)) {
      count = parseInt(count, 10);
    }

    if (count < 1000) {
      return count.toString();
    }
    if (count < 1000000) {
      const formatted = Math.floor((count / 1000) * 10) / 10;
      return `${formatted.toFixed(1)}${kSuffix}`;
    }
    const formatted = Math.floor((count / 1000000) * 10) / 10;
    return `${formatted.toFixed(1)}${mSuffix}`;
  } catch (error) {
    return TRUSTPILOT_REVIEW;
  }
};

export default formatTrustpilotCount;
